'use strict';

/* global $ */


import { interfaceName } from './settings';

import { AjaxForm } from './modules/ajax-form';
// import { Form } from './modules/ajax-form/form';
// import { AjaxHandler } from './modules/ajax-handler';
// import { Map } from './modules/map';
import { AjaxMore } from './modules/ajax-more';
import { Favorite } from './modules/favorite';
import { Goal } from './modules/goal';
import { Like } from './modules/like';
import { Menu } from './modules/menu';
import { Player } from './modules/player';
import { Responsive } from './modules/responsive';
//  import { Scroll } from './modules/scroll';
import { Tabs } from './modules/tabs';

class Proj {
	constructor() {
		this.init();
	}
	init() {
		this.interfaceName = interfaceName;
		console.log('[ interfaceName ]', this.interfaceName);

		// let store = sessionStorage.getItem('lradio');
		// if (!store) sessionStorage.setItem('lradio', JSON.stringify({ play: false }));

		this.ajaxForm = new AjaxForm();
		// this.ajaxHandler = new AjaxHandler();
		this.goal = new Goal({
			goals: [
				{
					selector: '.js-goal__link',
					event: 'click',
					handler: function() {
						$(window).trigger('main:reachGoal', $(this).data());
					}
				}, {
					selector: '.js-goal__form',
					event: 'submit',
					handler: function() {
						$(window).trigger('main:reachGoal', $(this).data());
					}
				}, {
					selector: window,
					event: 'goal ajaxForm:goal',
					handler: function(e, data) {
						$(window).trigger('main:reachGoal', data);
					}
				}
			]
		});

		this.responsive = new Responsive();
        // this.header = new Header({selector: '.js-header'});
        this.menu = new Menu({selector: '.js-menu'});
        this.tabs = new Tabs({selector: '.js-tabs'});
        this.like = new Like({selector: '.js-like'});
        this.favorite = new Favorite({selector: '.js-favorite'});
        this.ajaxMore = new AjaxMore({selector: '.js-ajax-more'});
        //$('body').on('DOMSubtreeModified', '.js-ajax-more', function() {
        //    console.log('changed');
        //});
        this.player = new Player({selector: '.js-player'});
        // this.scroll = new Scroll({selector: '.js-scroll-to'});
	}
}

$(function() {
	window.proj = new Proj();
});
